var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages"},[_vm._m(0),_c('div',{staticStyle:{"margin-top":"10%","text-align":"center"}},[_c('div',{staticClass:"submittext"},[_vm._v(_vm._s('签约完成'))])]),_c('button',{staticClass:"button",on:{"click":_vm.returnBack}},[_vm._v("返回")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexbox"},[_c('img',{attrs:{"src":require("../../assets/face.png")}})])
}]

export { render, staticRenderFns }